export const teamSmartImagesApiSavingSelector = state =>
  state.api.teamSmartImages.isSaving;

export const teamSmartImagesErrorsSelector = state =>
  state.api.teamSmartImages.errors;
